import {Component} from '@angular/core';

import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDL5S7zFDMVxjZjGZ33QnIVAczPOukMtiE",
  authDomain: "qlift-a93e6.firebaseapp.com",
  projectId: "qlift-a93e6",
  storageBucket: "qlift-a93e6.appspot.com",
  messagingSenderId: "838511406278",
  appId: "1:838511406278:web:3041a49dec320b0e36bbc7"
};
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor() {
    const app = initializeApp(firebaseConfig);
  }
}
